import React, { useState } from "react";
import enFlag from '../../images/English_Flag.svg';
import deFlag from '../../images/German_Flag.svg';
import arrowup from '../../images/arrow-up.svg';

const LangSelector = () => {

    const [toggleCheckLang, setToggleCheckLang] = useState(false);

    const ToggleServersLang = () => {
        if (toggleCheckLang === false) {
            setToggleCheckLang(true);
        }
        else {
            setToggleCheckLang(false);
        }
    }

    return (
        <>
            {process.env.GATSBY_LANG === "de" ?
                <div className="cp-lang">
                    <button className={`${toggleCheckLang ? 'l-active' : 'l-inactive'} l--flex`} onClick={ToggleServersLang}>
                        <img src={deFlag} alt="German" />
                        <img className="l-arrow" src={arrowup} alt="" />
                    </button>
                    {toggleCheckLang &&
                        <ul>
                            <li className="is--active">
                                <span className="l--flex">
                                    <img src={deFlag} alt="German" />
                                    <span>DE</span>
                                </span>
                            </li>
                            <li>
                                <a href="https://planful.com/" className="l--flex">
                                    <img src={enFlag} alt="German" />
                                    <span>EN</span>
                                </a>
                            </li>
                        </ul>
                    }
                </div>
                :
                <div className="cp-lang">
                    <button className={`${toggleCheckLang ? 'l-active' : 'l-inactive'} l--flex`} onClick={ToggleServersLang}>
                        <img src={enFlag} alt="English" />
                        <img className="l-arrow" src={arrowup} alt="" />
                    </button>
                    {toggleCheckLang &&
                        <ul>
                            <li className="is--active">
                                <span className="l--flex">
                                    <img src={enFlag} alt="English" />
                                    <span>EN</span>
                                </span>
                            </li>
                            <li>
                                <a href="https://planful.com/de/" className="l--flex">
                                    <img src={deFlag} alt="German" />
                                    <span>DE</span>
                                </a>
                            </li>
                        </ul>
                    }
                </div>
            }
        </>
    );
}

export default LangSelector;